<template>
  <ion-page>
    <ion-content>
      <header-section />
      <div class="container-wrapper">
        <div class="comment-content">
          <div class="comment-inner" v-if="post">
            <div class="post-owner">
              <div
                class="profile-image"
                v-if="
                  post.user && post.user.image !== 'profiles/placeholder.png'
                "
              >
                <img :src="`https://hyreads.com/${post.user.image}`" alt="" />
              </div>
              <div v-else>
                <avatar
                  :username="post.user.name"
                  style="width: 2.7rem; height: 2.7rem"
                  v-if="post.user"
                ></avatar>
              </div>
              <h3 v-if="post.user">{{ post.user.username }}</h3>
            </div>
            <div
              class="post sentence-post"
              v-if="post && post.description !== 'undefined'"
              v-html="post.description"
            ></div>
            <div
              class="post post-photo"
              v-if="post && post.images && post.images.length != 0"
            >
              <div id="photo-grid">
                <photo-grid
                  :box-height="'300px'"
                  :box-width="'100%'"
                  :excess-text="'+ {{count}}'"
                  :home_grid="true"
                  @clickExcess="triggerClick"
                >
                  <img
                    v-for="(image, index) in post.images"
                    :src="`https://hyreads.com/${image.image}`"
                    :key="index"
                  />
                </photo-grid>
              </div>
            </div>
            <div
              class="video-post"
              v-if="post && post.videos && post.videos != 0"
            >
              <photo-grid
                :box-height="'300px'"
                :box-width="'100%'"
                :excess-text="'+ {{count}}'"
                @clickExcess="triggerClick"
              >
                <video
                  style="width: 100%; height: 100%"
                  v-for="(video, index) in post.videos"
                  :key="index"
                  controls
                  autoplay
                >
                  <source
                    :src="`https://hyreads.com/${video.video}`"
                    type="video/mp4"
                  />
                  <source
                    :src="`https://hyreads.com/${video.video}`"
                    type="video/ogg"
                  />
                  <source
                    :src="`https://hyreads.com/${video.video}`"
                    type="video/webm"
                  />
                </video>
              </photo-grid>
            </div>
            <div class="all-comments">
              <h5>All Comments</h5>
            </div>
            <div class="comments-list">
              <div class="comment">
                <div class="comment-body">
                  <div class="create-comment" v-if="$store.state.authuser">
                    <div
                      class="profile-image"
                      v-if="
                        $store.state.authuser &&
                        $store.state.authuser.image !==
                          'profiles/placeholder.png'
                      "
                    >
                      <img
                        :src="`https://hyreads.com/${$store.state.authuser.image}`"
                        alt=""
                      />
                    </div>
                    <div v-else>
                      <avatar
                        :username="$store.state.authuser.name"
                        style="width: 2rem; height: 2rem"
                      ></avatar>
                    </div>
                    <div class="input-comment">
                      <textarea
                        name=""
                        class="comment-control"
                        cols="20"
                        rows="10"
                        placeholder="Write a comment..."
                        v-model="comment"
                        v-on:keyup.enter="newComment(post.id)"
                        @keydown.enter.exact.prevent=""
                      ></textarea>
                    </div>
                    <span @click.prevent="newComment(post.id)">
                      <i><svg-icon name="message" /></i>
                    </span>
                  </div>
                  <single-comment
                    :comment="comment"
                    :collection="comment.children"
                    v-for="(comment, index) in post.comments"
                    :key="index"
                  ></single-comment>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonContent,
  IonRefresher,
  IonRefresherContent,
  IonPage,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonBackButton,
  IonHeader,
} from "@ionic/vue";
import HeaderSection from "./navBar/header.vue";
import Avatar from "../Avatar";
import PhotoGrid from "../PhotoGridComponent";
import SvgIcon from "../SvgIcon.vue";
export default {
  components: {
    IonContent,
    IonRefresher,
    IonRefresherContent,
    IonPage,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonBackButton,
    IonHeader,
    HeaderSection,
    Avatar,
    PhotoGrid,
    SvgIcon,
  },
  data() {
    return {
      post: null,
      comment: null,
      parent: "",
    };
  },
  methods: {
    newComment(id) {
      let formData = new FormData();
      formData.append("feed_id", id);
      formData.append("parent", this.parent);
      formData.append("content", this.comment);
      axios
        .post(`${this.$store.state.endpoints.newComment}`, formData, {
          headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
        })
        .then((response) => {
          this.post.comments.push(response.data.data);
        });

      this.comment = null;
    },
  },
  mounted() {},
  created() {
    axios
      .get(
        `${this.$store.state.endpoints.singlePostView}${this.$route.params.id}/`,
        {
          headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
        }
      )
      .then((response) => {
        this.post = response.data;
        console.log();
      });
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@500;700&display=swap");
@import "./../styles/font-poppins.css";
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
ul {
  list-style: none;
}
a {
  text-decoration: none;
}
body {
  font-family: "Poppins", sans-serif;
  background: rgb(240, 240, 240);
  font-weight: 500;
}
.inner-row {
  width: 85%;
  margin: auto;
}
.profile-image {
  width: 2.7rem;
  aspect-ratio: 1/1;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 0px 1px 1px gainsboro;
}
img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

header {
  width: 100%;
  background: white;
  position: fixed;
  z-index: 10;
  height: 70px;
  box-shadow: 0px 1px 2px rgb(231, 231, 231);
}
header .inner-row {
  height: inherit;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header .logo-section {
  width: 50px;
  height: 50px;
}
.logo-section img {
  width: 135px;
}
.left-nav,
.right-nav {
  display: flex;
  align-items: center;
}

header .search-bar {
  background: whitesmoke;
  margin-left: 5%;
  width: 300px;
  padding: 0.5rem;
  border-radius: 1.2rem;
  -webkit-border-radius: 1.2rem;
  -moz-border-radius: 1.2rem;
  -ms-border-radius: 1.2rem;
  -o-border-radius: 1.2rem;
}
.search-control {
  border: none;
  background: transparent;
  outline: none;
  width: 80%;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  color: #333;
}

@media (max-width: 700px) {
  .navTrigger {
    display: block;
  }
  .middle-container {
    width: 100%;
    display: block;
    margin-bottom: 9rem;
  }
  .main-wrapper .inner-row {
    grid-template-columns: repeat(1, 1fr);
    display: block;
  }
  header .search-bar,
  .right-nav,
  .sidebar {
    display: none;
  }
  .mobile-navigation {
    display: flex;
  }
}
.quick-links {
  margin-right: 5%;
  display: flex;
}
.quick-links .notify,
.quick-links .message {
  font-size: 1.5rem;
  cursor: pointer;
  color: rgb(80, 80, 80);
}
.profile-section {
  display: flex;
  align-items: center;
}
.profile-name {
  display: flex;
  align-items: center;
}
.profile-name h2 {
  font-size: 0.9rem;
  margin-left: 0.5rem;
  color: rgb(80, 80, 80);
  font-family: "Poppins";
  width: 100px;
}
.profile-name span {
  font-size: 1.2rem;
  cursor: pointer;
}

.mobile-navigation {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  z-index: 99;
  display: none;
  justify-content: space-around;
  padding: 0.5rem 0;
  border-top: 1px solid gainsboro;
}
.mobile-nav-item a {
  color: #333;
}
.mobile-nav-item i {
  font-size: 1.3rem;
}

.mobile-sidebar {
  height: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: white;
  width: 50%;
  padding: 4rem 0.5rem;
  box-shadow: 0px 1px 1px 1px rgb(163, 163, 163);
  margin-right: -100%;
  transition: all 1s ease;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -ms-transition: all 1s ease;
  -o-transition: all 1s ease;
}
.mobile-sidebar.active {
  height: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: white;
  width: 50%;
  padding: 4rem 0.5rem;
  box-shadow: 0px 1px 1px 1px rgb(163, 163, 163);
  margin-right: 0;
}
.mobile-nav-link {
  display: block;
  line-height: 40px;
  color: #222;
  font-size: 0.9rem;
}

.mobile-profile {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin: 1rem 0;
}
.mobile-profile .profile-text p {
  font-size: 0.7rem;
  color: #444;
}
.mobile-sidebar .logout {
  padding: 0.5rem 0;
  margin-top: 1rem;
  border-top: 1px solid gainsboro;
}
.mobile-sidebar .logout a {
  font-size: 0.9rem;
  color: #222;
}

.navTrigger {
  cursor: pointer;
  width: 30px;
  height: 25px;
  margin: auto;
  position: absolute;
  right: 20px;
  top: 20px;
  display: none;
  z-index: inherit;
}
.navTrigger i {
  background: #222;
  width: 100%;
  content: "";
  display: block;
  height: 4px;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -ms-border-radius: 2px;
  -o-border-radius: 2px;
}
.navTrigger i:nth-child(1) {
  animation: outTp 0.8s backwards;
  -webkit-animation: outTp 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger i:nth-child(2) {
  margin: 5px 0;
  animation: outMd 0.8s backwards;
  -webkit-animation: outMd 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger i:nth-child(3) {
  animation: outBtm 0.8s backwards;
  -webkit-animation: outBtm 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger.active i:nth-child(1) {
  -webkit-animation: inTp 0.8s forwards;
  animation: inTp 0.8s forwards;
}

.navTrigger.active i:nth-child(2) {
  -webkit-animation: inMd 0.8s forwards;
  animation: inMd 0.8s forwards;
}

.navTrigger.active i:nth-child(3) {
  -webkit-animation: inBtm 0.8s forwards;
  animation: inBtm 0.8s forwards;
}
/*Keyframes*/
@keyframes inMd {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes outMd {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes inTp {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(9px) rotate(0deg);
  }
  100% {
    transform: translateY(9px) rotate(135deg);
  }
}

@keyframes outTp {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(9px) rotate(0deg);
  }
  100% {
    transform: translateY(9px) rotate(135deg);
  }
}

@keyframes inBtm {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-9px) rotate(0deg);
  }
  100% {
    transform: translateY(-9px) rotate(135deg);
  }
}

@keyframes outBtm {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-9px) rotate(0deg);
  }
  100% {
    transform: translateY(-9px) rotate(135deg);
  }
}

@media (max-width: 930px) {
  .right-container {
    display: none;
  }
  .main-wrapper .inner-row {
    grid-template-columns: 4rem auto;
    gap: 1rem;
  }
}
@media (max-width: 700px) {
  .navTrigger {
    display: block;
  }
  .middle-container {
    width: 100%;
    display: block;
    margin-bottom: 9rem;
  }
  .main-wrapper .inner-row {
    grid-template-columns: repeat(1, 1fr);
    display: block;
  }
  header .search-bar,
  .right-nav,
  .sidebar {
    display: none;
  }
  .mobile-navigation {
    display: flex;
  }
}
/*Keyframes*/
@keyframes inMd {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes outMd {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes inTp {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(9px) rotate(0deg);
  }
  100% {
    transform: translateY(9px) rotate(135deg);
  }
}

@keyframes outTp {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(9px) rotate(0deg);
  }
  100% {
    transform: translateY(9px) rotate(135deg);
  }
}

@keyframes inBtm {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-9px) rotate(0deg);
  }
  100% {
    transform: translateY(-9px) rotate(135deg);
  }
}

@keyframes outBtm {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-9px) rotate(0deg);
  }
  100% {
    transform: translateY(-9px) rotate(135deg);
  }
}

.container-wrapper {
  position: relative;
  top: 70px;
  display: flex;
  justify-content: center;
}
.comment-content {
  width: 550px;
  // height: 88vh;
  overflow-y: scroll;
  background: rgb(250, 250, 250);
  margin-bottom: 35px;
}
.comment-inner {
  padding: 1rem;
}
.comment-title {
  display: block;
  text-align: center;
  position: sticky;
  top: 0;
  background-color: #fff;
  border-bottom: 1px solid gainsboro;
  padding: 0.8rem;
  margin-bottom: 1rem;
}
.comment-title span {
  position: absolute;
  left: 5%;
  top: 4px;
  font-size: 30px;
  cursor: pointer;
}
.post-owner {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.post-photo img {
  height: 300px;
  border-radius: 1rem;
}
.all-comments {
  margin: 1rem 0;
}
.comment-body p {
  font-size: 0.8rem;
}
::-webkit-scrollbar {
  width: 0;
}

@media (max-width: 600px) {
  .comment-content {
    width: 90%;
    margin-bottom: 35px;
  }
}
.post .sentence-post,
.post .video-post {
  margin: 1rem 0;
}

.post .post-photo {
  overflow: hidden;
  margin: 0.7rem 0;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
}
.create-comment {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.5rem;
  margin: 1rem 0;
}
.create-comment .profile-image {
  width: 30px;
  height: 30px;
}

.create-comment span {
  font-size: 30px;
  color: rgb(0, 110, 255);
  cursor: pointer;
}
.input-comment {
  width: 85%;
}
.input-comment .comment-control {
  height: 40px;
  width: 100%;
  padding: 0.5rem;
  font-family: "Poppins";
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
  background-color: #ddd;
  border: none;
  outline: none;
  resize: none;
  color: #333;
}
</style>
